import isEmpty from 'lodash/isEmpty';
import {
  BUILT_IN_CHART_TYPES,
  defaultFormFields,
  INTERNAL_CHART_TYPES
} from '@experiment-management-shared/constants';

import { Panel, PanelType } from '@experiment-management-shared/types';

import isArray from 'lodash/isArray';
import randomstring from 'randomstring';

// remove random ids or react-query will invalidate cache!
export const generateAutoGeneratedMetricsPanel = (
  metricName: string
): Panel => ({
  chartId: randomstring.generate(6),
  chartName: metricName,
  chartType: INTERNAL_CHART_TYPES.autoGeneratedMetrics as PanelType,
  metricName,
  autoGenerated: true
});
export const generateAutoGeneratedCurvePanel = (
  fileName: string,
  experimentsCount: number
) => ({
  ...(defaultFormFields[BUILT_IN_CHART_TYPES.curves] as Panel),
  chartName: fileName,
  chartType: BUILT_IN_CHART_TYPES.curves as PanelType,
  chartId: randomstring.generate(6),
  assetNames: [fileName],
  experimentsCount,
  autoGenerated: true
});
export const generateAutoGeneratedDataframePanel = (
  fileName: string,
  experimentsCount: number
) => ({
  ...(defaultFormFields[BUILT_IN_CHART_TYPES.data] as Panel),
  chartType: BUILT_IN_CHART_TYPES.data as PanelType,
  chartId: randomstring.generate(6),
  fileName,
  experimentsCount,
  autoGenerated: true
});

export const generateAutoGeneratedImagePanel = (
  images: string[],
  experimentsCount: number
): Panel => ({
  ...(defaultFormFields[BUILT_IN_CHART_TYPES.image] as Panel),
  chartId: randomstring.generate(6),
  chartType: BUILT_IN_CHART_TYPES.image as PanelType,
  images,
  experimentsCount,
  autoGenerated: true
});

export const getMetricOfAutoGeneratedPanel = (panel: Panel) => {
  if (!isEmpty(panel.selectedYAxis)) {
    if (isArray(panel.selectedYAxis)) {
      return panel.selectedYAxis[0];
    }

    return panel.selectedYAxis;
  }

  if (panel.chartType === BUILT_IN_CHART_TYPES['BuiltIn/Line']) {
    return panel.metricNames?.[0];
  }

  if (panel.chartType === BUILT_IN_CHART_TYPES['BuiltIn/Bar']) {
    return panel.metrics?.[0]?.name;
  }
};
